"use client"

const readCookieValue = (name: string): string | null => {
  if (typeof document === "undefined") return null
  const rawEntries = document.cookie.split(";")
  for (const entry of rawEntries) {
    const trimmed = entry.trim()
    if (!trimmed.startsWith(`${name}=`)) continue
    const value = decodeURIComponent(trimmed.slice(name.length + 1))
    return value || null
  }
  return null
}

export const getClientAuthToken = (): string | null => {
  const token = readCookieValue("_auth_token")
  if (!token) return null
  const trimmed = token.trim()
  return trimmed || null
}

export const getClientAuthHeaders = (): HeadersInit => {
  const token = getClientAuthToken()
  if (!token) return {}
  return { Authorization: `Bearer ${token}` }
}

